var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Избрани снимки: "+_vm._s(_vm.images.length))]),_vm._v(" "),_c('draggable',{staticClass:"dragArea ",attrs:{"list":_vm.images,"group":"people"}},_vm._l((_vm.images),function(element){return _c('img',{key:element.id,staticClass:"card-img-top imgs-sortable",attrs:{"src":element.icon,"alt":element.icon},on:{"dblclick":function($event){return _vm.deleteImage(element.id)}}})}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1c07b0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app_modules/SortableImages.vue
// module id = 186
// module chunks = 0